import jwt_decode from 'jwt-decode'
import { uploadFilePreflight, uploadFile } from '../../api/documents'
import getToken from '../account/getToken'

export default store => async ({ file, name, destinationFolder }) => {
  let token, accessToken
  try {
    token = await getToken(store)()
    accessToken = jwt_decode(token).accessToken
  } catch (err) {
    return
  }

  return uploadFilePreflight({ name, destinationFolder, file, accessToken })
    .then(response => {
      if (response.status === 409) {
        throw new Error('item_name_in_use')
      }
      if (response.status !== 200) {
        throw new Error('unknown_error')
      }
      return response.json()
    })
    .then(response => {
      const { upload_url } = response
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader()

        fileReader.onload = function () {
          resolve({ fileRaw: fileReader.result, uploadUrl: upload_url })
        }
        fileReader.onerror = function () {
          reject('Could not create a file reader')
        }

        fileReader.readAsArrayBuffer(file)
      })
    })
    .then(({ fileRaw, uploadUrl }) => {
      const formData = new FormData()

      formData.append(
        'attributes',
        JSON.stringify({
          name,
          parent: {
            id: destinationFolder,
          },
        }),
      )

      const blob = new Blob([fileRaw], { type: file.type })
      formData.append('file', blob)

      return uploadFile({ uploadUrl, accessToken, formData })
    })
    .then(response => {
      if (response.status === 409) {
        throw new Error('item_name_in_use')
      }
      if (response.status !== 201) {
        throw new Error('upload_error')
      }

      return response.json()
    })
    .then(response => response.entries[0])
}
